import { format } from 'date-fns';
import { UPCOMING, COMPLETED, AVAILABLE } from 'mocks/study';
import dayjs from 'dayjs';

export const weekday = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];

export const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

/**
 *
 * @param {number} num
 * @returns Time stamp based on the number passed in e.g input 1 will return 01:00 PM
 */
export const numberToTime = (num) => {
  const date = new Date();
  date.setHours(num, 0, 0);
  return format(date, 'p');
};

export const formatDate = (date, format = 'YYYY-MM-DD') => {
  return dayjs(date).format(format);
};

export const minutesBetweenDates = (startDate, endDate) => {
  var diff = endDate.getTime() - startDate.getTime();
  return diff / 60000;
};

// HyperWallet expects YYYY-MM-DD date format
export const toHyperWalletTimeFormat = (date) => {
  return new Date(date).toISOString().slice(0, 10);
};

export const getTimelineDateTitles = (dateString) => {
  // TODO: remove this when the date are fixed from backend
  if (dateString === UPCOMING) {
    return UPCOMING;
  }
  if (dateString === AVAILABLE) {
    return AVAILABLE;
  }
  if (dateString === COMPLETED) {
    return COMPLETED;
  }

  const date = new Date(dateString);
  const dayOfWeek = weekday[date.getDay()]?.toUpperCase();
  const month = months[date.getMonth()]?.toUpperCase();
  return `${dayOfWeek}, ${date.getDay()} ${month}, ${date.getFullYear()}`;
};

export const daysBetweenDates = (startDate, endDate) =>
  Math.floor(
    (Date.UTC(endDate.getFullYear(), endDate.getMonth(), endDate.getDate()) -
      Date.UTC(
        startDate.getFullYear(),
        startDate.getMonth(),
        startDate.getDate()
      )) /
      (1000 * 60 * 60 * 24)
  );

export const getDaysOfMonth = (month, year) => {
  if (month === '') return [];
  const numberOfDaysInMonth = new Date(
    year !== '' ? year : new Date().getFullYear(),
    month,
    0
  ).getDate();

  return Array.from({ length: numberOfDaysInMonth }).map((_, index) => {
    const day = `${index + 1}`.padStart(2, '0');
    return {
      label : day,
      value : day,
    };
  });
};

export const getDateDifference = (start, end, unit) =>
  dayjs(start).diff(end, unit);

export const isBelowAge = (dateOfBirth, years) =>
  getDateDifference(new Date(), dateOfBirth, 'year') < years;

export const getArrayOfYears = () => {
  const thisYear = new Date().getFullYear();
  const years = [];
  for (var i = thisYear; i >= 1922; i--) {
    years.push(i);
  }
  return years;
};

export const addToDate = (date, digit, unit) => {
  return dayjs(date).add(digit, unit);
};

export const subtractFromDate = (date, digit, unit) => {
  return dayjs(date).subtract(digit, unit);
};

export const today = new Date();

export const isBetweenDates = (
  referenceDate,
  startDate,
  endDate,
  interval = '[)'
) => dayjs(referenceDate).isBetween(startDate, endDate, 'day', interval);

export const shortMonthToNumericString = {
  Jan : '01',
  Feb : '02',
  Mar : '03',
  Apr : '04',
  May : '05',
  Jun : '06',
  Jul : '07',
  Aug : '08',
  Sep : '09',
  Oct : '10',
  Nov : '11',
  Dec : '12',
};

export const sumArrayObject = (data = []) =>
  data.reduce(
    (partialSum, item) =>
      partialSum + (isNaN(item.value) ? 0 : Number(item.value)),
    0
  );
  
export const groupDataByDate = (data = []) => {
  let groups = data.reduce((groups, item) => {
    const date = item.date;
    if (!groups[date]) {
      groups[date] = [];
    }
    groups[date].push(item);
    return groups;
  }, {});
  for (const date in groups) {
    const group = groups[date];
    groups[date] = sumArrayObject(group) / group.length;
  }
  return groups;
};
